/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

export const createReadmeStarter = (randomFile: string) =>
  `# My First Readme!

This is a really simple readme to help you get started.

## Purpose

The main purpose is to illustrate how to add content to your readme.  Specifically:

* Linking to files within your sandbox is as simple as providing a [link](./${randomFile}).

## Do more

Now that you have created a readme, you can also create a walkthrough for your code. Use the button below to get started!

## Available features

This markdown file can support most markdown functionality. Expand the detail below to see full functionality:

<details>
  <summary>Click to expand!</summary>

# h1 Heading
## h2 Heading
### h3 Heading
#### h4 Heading


## Horizontal Rules

___

---

***

## Emphasis

**This is bold text**

__This is bold text__

*This is italic text*

_This is italic text_

~~Strikethrough~~


## Blockquotes

> Blockquotes!

## Lists

Unordered

+ Create a list by starting a line with \`+\`, \`-\`, or \`*\`
+ Sub-lists are made by indenting 2 spaces:
  - Marker character change forces new list start:
    * Ac tristique libero volutpat at
    + Facilisis in pretium nisl aliquet
    - Nulla volutpat aliquam velit
+ Very easy!

Ordered

1. Lorem ipsum dolor sit amet
2. Consectetur adipiscing elit
3. Integer molestie lorem at massa


1. You can use sequential numbers...
1. ...or keep all the numbers as \`1.\`

Start numbering with offset:

57. foo
1. bar


## Code

Inline \`code\`

Block code "fences"

\`\`\`
var foo = function (bar) {
  return bar++;
};
\`\`\`

## Tables

### Left aligned columns

| Option | Description |
| ------ | ----------- |
| data   | path to data files to supply the data that will be passed into templates. |
| engine | engine to be used for processing templates. Handlebars is the default. |
| ext    | extension to be used for dest files. |

### Right aligned columns

| Option | Description |
| ------:| -----------:|
| data   | path to data files to supply the data that will be passed into templates. |
| engine | engine to be used for processing templates. Handlebars is the default. |
| ext    | extension to be used for dest files. |


## Images

![Minion](https://octodex.github.com/images/minion.png)
![Stormtroopocat](https://octodex.github.com/images/stormtroopocat.jpg "The Stormtroopocat")

Like links, Images also have a footnote style syntax

![Alt text][id]

With a reference later in the document defining the URL location

[id]: https://octodex.github.com/images/dojocat.jpg  "The Dojocat"
</details>
`;
